var alignment_rtlignore_default = {
  "alignLeft": "_4wndY",
  "textWrapNowrap": "atx9f",
  "alignRight": "CmJqI",
  "alignCenter": "Dv5fV",
  "sizeFullWidth": "_25--6",
  "renderedInTable": "ZxSGY",
  "sizeOriginal": "Dvquq",
  "sizeContent": "IcG27",
  "sizeSmall": "hcJTo",
  "sizeSmallCenter": "e6kOE",
  "flex": "JR6fM",
  "LEFT": "FlmSL",
  "CENTER": "HZbzS",
  "RIGHT": "maEas",
  "AUTO": "rIsue",
  "JUSTIFY": "MqvCC"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
